import React from 'react';

import { ConstantPermissions } from 'contexts/useConstant';
import InvoiceSharedFile from './InvoiceSharedFile';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

export default function InvoiceManual() {
  return (
    <InvoiceSharedFile
      title="Listado de facturas manuales"
      excelName="Facturas-manuales"
      originType="M"
      permission={{
        store: ConstantPermissions.PURCH_PURCHASES_STORE,
        update: ConstantPermissions.PURCH_PURCHASES_UPDATE
      }}
    />
  );
}
